// src/pages/vsession.jsx
import React, { useEffect, useRef, useState } from "react";
import "../../../styles/VideoSession.css";
import { FaMicrophoneSlash, FaVideoSlash, FaMicrophone } from "react-icons/fa";
import AiModelIcon from "../../../assets/icons/aimodel.svg";
import VoiceModelIcon from "../../../assets/icons/voicemodel.svg";
import EndCallIcon from "../../../assets/icons/endcall.svg";
import { ReactComponent as VoiceAudioIcon } from "../../../assets/icons/audiomic.svg";
import { ReactComponent as VideoIcon } from "../../../assets/icons/video.svg";
import { useWebSocketChat } from "../../../socket/useSocket";
import { AuthServices } from "../../auth/services/AuthServices";
import dietician from "../../../assets/icons/dietician.svg";
import psychologist from "../../../assets/icons/psychologistai.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ConnectedIcon } from "../../../assets/icons/connectedicon.svg";
import Lottie from "lottie-react";
import talkingWave from "../../../assets/icons/talkingwave.json";
import defaultAvatar from "../../../assets/icons/logo.svg"; // fallback if no DB photo
import VirtualBackgroundOverlay from "../pages/VirtualBackgroundOverlay";
import logo from "../../../assets/icons/NewLogo.png";



const VideoSession = () => {

  
  localStorage.setItem("chat_mode", "video");
  const [isMuted, setIsMuted] = useState(false);
  const [isVideoOff, setIsVideoOff] = useState(false);
  const [showModelModal, setShowModelModal] = useState(false);
  const [showVoiceModal, setShowVoiceModal] = useState(false);
  const [showEndModal, setShowEndModal] = useState(false);
  
  const [selectedVoice, setSelectedVoice] = useState(null);
  const [user, setUser] = useState();
  const [selectedExpert, setSelectedExpert] = useState(() => {
    return localStorage.getItem("selectedExpert") || "";
  });
  // ...existing state
  const [isBotTalking, setIsBotTalking] = useState(false);
  const [sessionEnded, setSessionEnded] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [modalMessage, setModalMessage] = useState(false);
  const [selectedModelType, setSelectedModelType] = useState(selectedExpert);
  const [subtitleText, setSubtitleText] = useState(""); // full text of current audio
  const [highlightIndex, setHighlightIndex] = useState(0); // index of highlighted char




  const {
    socket,
    updatePersona,
    updatePatientId,
    sendAudio,
    audioChunksRef,
    setBotStatus,
    botStatus,
  } = useWebSocketChat({
    setCompleteAudio: () => { },
    onStreamingStart: (data) => handleStreamingStart(data),
    onStreamingText: () => { },
    onStreamingAudio: (data) => handleStreamAudio(data),
    onStreamingComplete: (data) => handleStreamingComplete(data),
    onStreamingError: (data) => handleStreamError(data),
    onTranscription: () => { },
    onConversationHistory: () => { },
  });

  const userVideoRef = useRef(null);
  const audioRef = useRef(new Audio());
  const audioQueue = useRef([]);
  const isProcessingQueue = useRef(false);
  const streamRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const isRecordingRef = useRef(false);
  const navigate = useNavigate();

  const handleVideoToggle = () => {
    setIsVideoOff((prev) => {
      const newVideoOff = !prev;
      const stream = userVideoRef.current?.srcObject;
      if (stream) {
        const videoTracks = stream.getVideoTracks();
        if (newVideoOff) {
          videoTracks.forEach((track) => {
            track.stop();
            stream.removeTrack(track);
          });
        } else {
          navigator.mediaDevices
            .getUserMedia({ video: true })
            .then((newStream) => {
              const newVideoTrack = newStream.getVideoTracks()[0];
              stream.addTrack(newVideoTrack);
              userVideoRef.current.srcObject = stream;
            })
            .catch((err) => {
              console.error("Failed to restart camera:", err);
            });
        }
      }
      return newVideoOff;
    });
  };

  const handleMuteToggle = () => {
    setIsMuted((prev) => {
      const newMuted = !prev;
      const audioTracks = userVideoRef.current?.srcObject?.getAudioTracks();
      if (audioTracks && audioTracks.length > 0) {
        audioTracks[0].enabled = !newMuted;
      }
      /*if (newMuted) {
        setIsMuted(newMuted);
        stopRecording();
        setBotStatus(null);

      } else {
        setIsMuted(false);
        startRecording();
      }*/

      return newMuted;
    });
  };

  const handleModelSelect = (type) => {
    setSelectedModelType(type.target.innerText);
  };

  const handleStreamingStart = (data) => {
    console.log(data);
  };

  const handleStreamAudio = (data) => {
    if (!data || !data.audio) return;
     const text = data.text || "…"; // get subtitle text from server
     enqueueAudio(data.audio, text);
  };

  const handleSetVoice = (voice) => {
    setSelectedVoice(voice.target.innerText);
  };

  const handleVoiceSelect = () => {
    let mappedVoice;
    setModalMessage("Changing model voice to "+selectedVoice);

    switch (selectedVoice) {
      case "Nova – Female, Soft":
        mappedVoice = "nova";
        break;
      case "Alloy – Neutral":
        mappedVoice = "alloy";
        break;
      case "Echo – Male":
        mappedVoice = "echo";
        break;
      case "Fable – Female":
        mappedVoice = "fable";
        break;
      case "Onyx – Male, Deep":
        mappedVoice = "onyx";
        break;
      case "Shimmer – Female, Clear":
        mappedVoice = "shimmer";
        break;
      default:
        mappedVoice = "default";
    }

    localStorage.setItem("selectedVoice", mappedVoice);

    
    setTimeout(() => {
                // Start fade-out
              setFadeOut(true);
        
                // Preload current page in hidden iframe
              const iframe = document.createElement("iframe");
              iframe.style.display = "none";
              iframe.src = window.location.href;
              document.body.appendChild(iframe);

              iframe.onload = () => {
            // After fade completes (same as your animation time)
              setTimeout(() => {
              
              
              setModalMessage(false);

              setFadeOut(false); // reset fade
              // Optional: you can reset state or force remount
              // Forcing navigation to same route using React Router
              window.location.reload();
              //navigate(window.location.pathname, { replace: true, state: { reload: true } });
            }, 200); // match fade-out duration
        };

        //document.body.appendChild(iframe);
        
        }, 1000);


    //window.location.reload();

    setShowVoiceModal(false);
  };
/*
  const enqueueAudio = (audioData) => {
    const blob = new Blob(
      [Uint8Array.from(atob(audioData), (c) => c.charCodeAt(0))],
      {
        type: "audio/mpeg",
      }
    );
    audioQueue.current.push(blob);
    if (!isProcessingQueue.current) processAudioQueue();
  };

  const processAudioQueue = async () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (audioQueue.current.length === 0) {
      isProcessingQueue.current = false;
      setIsBotTalking(false);
      return;
    }

    isProcessingQueue.current = true;
    const blob = audioQueue.current.shift();
    const url = URL.createObjectURL(blob);

    audio.src = url;

    // mark "talking" while audio plays
    audio.onplay = () => setIsBotTalking(true);

    audio.onended = () => {
      URL.revokeObjectURL(url);
      if (audioQueue.current.length === 0) {
        isProcessingQueue.current = false;
        setIsBotTalking(false);
      }
      processAudioQueue(); // play next
    };

    audio.onerror = () => {
      URL.revokeObjectURL(url);
      isProcessingQueue.current = false;
      setIsBotTalking(false);
    };

    try {
      await audio.play();
    } catch (err) {
      console.error("Audio playback error:", err);
      audio.onerror();
    }
  };
*/


//------------------------------------------------------

const enqueueAudio = (audioData, text) => {
  audioQueue.current.push({ audioData, text });
  if (!isProcessingQueue.current) processAudioQueue();
};

const processAudioQueue = async () => {
  const audio = audioRef.current;
  if (!audio) return;
  if (audioQueue.current.length === 0) {
    isProcessingQueue.current = false;
    setSubtitleText("");
    setHighlightIndex(0);
    return;
  }

  isProcessingQueue.current = true;
  const { audioData, text } = audioQueue.current.shift();
  const blob = new Blob([Uint8Array.from(atob(audioData), (c) => c.charCodeAt(0))], { type: "audio/mpeg" });
  const url = URL.createObjectURL(blob);

  audio.src = url;
  setSubtitleText(text);
  setHighlightIndex(0);

  try {
    await audio.play();

    const words = text.split(" ");
    const duration = audio.duration || 3; // fallback
    const intervalTime = duration / words.length;

    let idx = 0;
    const interval = setInterval(() => {
      if (idx >= words.length) {
        clearInterval(interval);
        setHighlightIndex(0);
        return;
      }
      setHighlightIndex(idx);
      idx++;
    }, intervalTime * 1000);

    audio.onended = () => {
      clearInterval(interval);
      setHighlightIndex(0);
      URL.revokeObjectURL(url);
      processAudioQueue();
    };
  } catch (err) {
    console.error("Audio playback error:", err);
    URL.revokeObjectURL(url);
    isProcessingQueue.current = false;
  }
};


//------------------------------------------------------
  const startRecording = async () => {
    // Do not start recording if muted
    /*if (isMuted) {
      return;
    }*/

    if (!audioRef.current?.paused) {
      setTimeout(() => {
        startRecording();
      }, 500);
      return;
    }
    if (!navigator.mediaDevices || !window.MediaRecorder) {
      alert("Audio recording is not supported in this browser.");
      return;
    }

    setBotStatus("listening");
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
      });
      streamRef.current = stream;

      const mediaRecorder = new MediaRecorder(stream, {
        mimeType: "audio/webm",
      });

      mediaRecorderRef.current = mediaRecorder;
      audioChunksRef.current = [];

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      mediaRecorder.onstop = async () => {
        await sendAudio();
        isRecordingRef.current = false;
        stream.getTracks().forEach((track) => track.stop());
        mediaRecorderRef.current = null;
      };

      mediaRecorder.start();
      isRecordingRef.current = true;

      detectSilence(stream, 2000, 0.01, () => {
        stopRecording();
        isRecordingRef.current = false;
      });
    } catch (error) {
      console.error("Microphone error:", error);
      alert(`Microphone error: ${error.message}`);
    }
  };

  const detectSilence = (
    stream,
    silenceDuration = 2000,
    threshold = 0.01,
    onSilence = () => { }
  ) => {
    const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const analyser = audioCtx.createAnalyser();
    const source = audioCtx.createMediaStreamSource(stream);
    const data = new Uint8Array(analyser.fftSize);

    source.connect(analyser);

    let silenceStart = null;
    let startedTalking = false;

    const checkSilence = () => {
      analyser.getByteTimeDomainData(data);

      let sum = 0;
      for (let i = 0; i < data.length; i++) {
        const val = (data[i] - 128) / 128;
        sum += val * val;
      }
      const volume = Math.sqrt(sum / data.length);

      if (volume > threshold) {
        startedTalking = true;
        silenceStart = null;
      }

      if (startedTalking) {
        if (volume < threshold) {
          if (!silenceStart) silenceStart = performance.now();
          if (performance.now() - silenceStart > silenceDuration) {
            onSilence();
            audioCtx.close();
            return;
          }
        } else {
          silenceStart = null;
        }
      }

      requestAnimationFrame(checkSilence);
    };

    checkSilence();
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && isRecordingRef.current) {
      mediaRecorderRef.current.stop();
      isRecordingRef.current = false;
    }
  };

  const handleStreamingComplete = () => {
    //const newMuted = !isMuted;
        //setBotStatus(null);
   
        if (!sessionEnded) {
        startRecording();
      }
  };

  const handleStreamError = (data) => {
    console.log(data);
  };

  const fetchUserData = async () => {
    try {
      const response = await AuthServices.fetchUserData();
      const fetchedUser = response?.data?.data?.user;

      if (response.status !== 200) {
        socket?.close();
        localStorage.clear();
        navigate("/");
      }

      if (fetchedUser) {
        setUser(fetchedUser);
        localStorage.setItem("user", JSON.stringify(fetchedUser));

        if (fetchedUser?.patient_id) {
          updatePatientId(fetchedUser.patient_id);
        }
      }
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  };

  const handleSendSelectedModel = () => {
    setSelectedExpert(selectedModelType);
    localStorage.setItem("selectedExpert", selectedModelType);
    updatePersona(selectedModelType, { mode: "video" });
    setShowModelModal(false);

    if (socket && socket.readyState === 1) {
      socket.close();
    }

    window.location.reload();
  };

  useEffect(() => {
    const initCamera = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: {
            echoCancellation: true,
            noiseSuppression: true,
            autoGainControl: true,
          },
        });
        if (userVideoRef.current) {
          userVideoRef.current.srcObject = stream;
        }
      } catch (err) {
        console.error("Error accessing camera:", err);
      }
    };

    initCamera();

  }, []);

  useEffect(() => {
    if (socket?.readyState === 1) {
      const initRecording = async () => {
        await startRecording();
      };
      initRecording();
    }
  }, [socket]);

  useEffect(() => {
    if (audioRef.current) {
      processAudioQueue();
    }
  }, []);

  useEffect(() => {
    const getUser = async () => {
      fetchUserData();
    };
    getUser();
  }, []);

  useEffect(() => {
    if (user?.patient_id) {
      updatePersona(selectedExpert);
    }
  }, [user]);

  const userAvatar =
    (user?.profile_picture && user.profile_picture.trim())
      ? user.profile_picture
      : defaultAvatar;


  // -- Idle modal state
  const [showIdleModal, setShowIdleModal] = useState(false);

  useEffect(() => {
    const INACTIVE_MS = 10 * 60 * 1000; // 10MINUTES
    const POLL_MS = 1_000;      // check every second
    const KEY = "lastActivityAt";

    const stamp = () => {
      if (showIdleModal) return; // ⛔ don't close modal on activity
      localStorage.setItem(KEY, String(Date.now()));
    };

    // seed once
    if (!localStorage.getItem(KEY)) stamp();

    // listen ONLY when modal is not shown
    const events = ["click", "keydown", "mousemove", "touchstart", "scroll"];
    if (!showIdleModal) {
      events.forEach((e) => window.addEventListener(e, stamp, { passive: true }));
    }

    // visibility acts as activity only when modal is not shown
    const onVis = () => { if (!document.hidden && !showIdleModal) stamp(); };
    document.addEventListener("visibilitychange", onVis);

    // poll ONLY when modal is not shown
    let poll = null;
    if (!showIdleModal) {
      poll = setInterval(() => {
        const last = Number(localStorage.getItem(KEY) || 0);
        if (!last) return stamp();
        if (Date.now() - last >= INACTIVE_MS) setShowIdleModal(true);
      }, POLL_MS);
    }

    return () => {
      events.forEach((e) => window.removeEventListener(e, stamp));
      document.removeEventListener("visibilitychange", onVis);
      if (poll) clearInterval(poll);
    };
  }, [showIdleModal]);

  // the ONLY ways to close it:
  const handleStayActive = () => {
    localStorage.setItem("lastActivityAt", String(Date.now()));
    setShowIdleModal(false);
    setShowEndModal(false);
  };



 const cleanupSession = () => {
  // Stop camera stream
  const videoStream = userVideoRef.current?.srcObject;
  if (videoStream) {
    videoStream.getTracks().forEach((track) => track.stop());
    userVideoRef.current.srcObject = null;
  }

  // Stop mic recording
  if (mediaRecorderRef.current && isRecordingRef.current) {
    mediaRecorderRef.current.stop();
    isRecordingRef.current = false;
    mediaRecorderRef.current = null;
  }

  // Stop mic stream directly (important!)
  if (streamRef.current) {
    streamRef.current.getTracks().forEach((track) => track.stop());
    streamRef.current = null;
  }

  // Clear audio playback
  audioQueue.current = [];
  if (audioRef.current) {
    audioRef.current.pause();
    audioRef.current.src = "";
  }

  // Optional: close any websocket if used
  // if (socket && socket.readyState === 1) socket.close();
};


const cleanText = (htmlText) => {
    if (!htmlText) return "";
    return htmlText.replace(/<br\s*\/?>/gi, "\n").replace(/<\/?strong>/gi, "");
  };


const handleEndSession = () => {
  setSessionEnded(true);
  cleanupSession();
  setShowIdleModal(false);

  setIsClosing(true);
  //setModalMessage();
  setShowEndModal(true);

  // Wait 1s to show closing modal
  setTimeout(() => {
    // Start fade-out
    setFadeOut(true);

    // Preload /home in hidden iframe
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = "/home";

    iframe.onload = () => {
      // After fade completes (0.8s), switch
      setTimeout(() => {
        setShowEndModal(false);
        
         navigate("/home", { replace: true ,
                                            state: { 
                                            ischatVisible: true,    // pass any data you want
                                            session: localStorage.getItem("conversation_id") ??  null
                                            }
                                });
        window.location.href = "/home";
      }, 200);
    };

    document.body.appendChild(iframe);
  }, 1000);
};

  


  return (
    <div className="video-session-container">
      {/* <div className="status-bar">
        <p>Status: {socket?.readyState === 1 ? "Connected" : "Connecting"}</p>
        {botStatus && (
          <p>
            {botStatus === "thinking"
              ? "Thinking..."
              : botStatus === "listening"
                ? "Listening..."
                : botStatus}
          </p>
        )}
      </div> */}
      <div className="status-bar">
        {/* {botStatus && (
          <p className="bot-status">
            {botStatus === "thinking"
              ? "Thinking...🎙️ "
              : botStatus === "listening"
                ? "Listening...👂"
                : botStatus}
          </p>
        )} */}
        {botStatus === "listening" && !isMuted && (
          <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            Listening... <FaMicrophone />
          </span>
        )}
        {botStatus === "thinking" && isMuted && (
          <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            Thinking... <FaMicrophoneSlash />
          </span>
        )}
        {botStatus === "thinking" && !isMuted && (
          <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            Thinking... <FaMicrophone />
          </span>
        )}
        {/* <p className="connection-status">
          Status: {socket?.readyState === 1 ? "Connected" : "Connecting"}
        </p> */}
        <p className="connection-status">
          {socket?.readyState === 1 ? (
            <>
              <ConnectedIcon width={44} height={44} style={{ color: "green", marginRight: "6px" }} className="connected-icon" />
              {/* Connected */}
            </>
          ) : (
            <>Connecting.......{isMuted ? <FaMicrophoneSlash /> : <FaMicrophone />}</>
          )}
        </p>
      </div>
      <div className="video-block top">
        <img
          src={selectedExpert !== "psychologist" ? dietician : psychologist}
          alt="AI Therapist"
          className="video-feed"
        />

 <div 
          style={{
                  position: "fixed",      // Fix at screen
                          // Distance from bottom
                  left: "50%", 
                  top: "40%"  ,        // Center horizontally
                  transform: "translateX(-50%)", // Center alignment
                  fontSize: "24px",
                  background: "rgba(249, 244, 244, .7)", // Optional semi-transparent background*/
                  padding: "8px 16px",
                  width:"100%",
                  height:"40px",
                  borderRadius: "8px",
                  whiteSpace: "nowrap",
                  overflowX: "hidden",
                  zIndex: 1000,           // Make sure it's on top
                }}
          >
            {cleanText(subtitleText).split(" ").map((word, idx) => {
              const maxVisibleWords = 5; // show around 5 words at a time
              const start = Math.max(0, highlightIndex - 2); // center highlight
              const end = start + maxVisibleWords;

              if (idx < start || idx >= end) return null;

              const isHighlighted = idx === highlightIndex;

              return (
                <span
                  key={idx}
                  style={{
                    color: isHighlighted ? "#ff0019ff" : "#000",
                    fontStyle: isHighlighted ? "bold" :"normal",
                    fontSize:  isHighlighted ? "30px" :"24px",
                    transition: "color 0.1s linear",
                    marginRight: "4px",
                    display: "inline-block",
                  }}
                >
                  {word}
                </span>
              );
            })}
          </div>
          <div className="video-name-tag" style={{top:"94%"}}>{selectedExpert==="psychologist" ? "AI Therapist" :"AI Dietician"}</div>
         

      </div>

      {/* <div className="video-block bottom">
        {isVideoOff ? (
          <img
            src={userAvatar}
            alt="Your profile"
            className="video-feed"
            style={{ objectFit: "cover" }}
          />
        ) : (
          <video ref={userVideoRef} autoPlay muted className="video-feed" />
        )}

        <div className="video-name-tag">
          {(user?.first_name || user?.last_name)
            ? `${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim()
            : user?.name || user?.email?.split("@")[0] || "You"}
        </div>
      </div> */}
      <div className="video-block bottom"
      
      style={{
    /*backgroundColor: isVideoOff ? "linear-gradient(to bottom right, rgba(125, 74, 234, 0.9), rgba(172, 159, 239, 0.9))"
    : "none",
    backgroundColor: "transparent",*/
     backgroundImage: isVideoOff ? "none" : undefined
  }}
      
      >
        <video
          ref={userVideoRef}
          autoPlay
          playsInline
          muted
          style={{ display: "none" }}
        />

{!isVideoOff && (
        <VirtualBackgroundOverlay 
        videoId="userVideo" 
        videoRef={userVideoRef} 
        background={null} // replace with your background image URL
        logoUrl="https://care.prashasync.io/static/media/NewLogo.39a88dd05799b0825fe7.png"
        blur={true}   // switch to true for blur background
      />
  )}

        {isVideoOff && (
          <img
            src={userAvatar}
            alt="Your profile"
            className="video-feed"
            style={{ objectFit: "cover" , backgroundcolor:"#AC9FEF"}}
          />
        )}

        <div className="video-name-tag">
          {(user?.first_name || user?.last_name)
            ? `${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim()
            : user?.name || user?.email?.split("@")[0] || "You"}
        </div>
      </div>
      {isBotTalking && (
        <div
          className="video-anim-overlay"
          aria-hidden="true"
          style={{
            position: "absolute",
            top: "50%",
            right: "20px",        // distance from right edge
            transform: "translateY(-50%)", // center vertically
            pointerEvents: "none",
            zIndex: 9999,
          }}
        >
          <Lottie
            animationData={talkingWave}
            loop
            autoplay
            style={{ width: 80, height: 80 }}
          />
        </div>
      )}


      <footer className="session-controls">
        <button className="circle-btn" onClick={handleMuteToggle} title={isMuted ? "Turn on microphone" : "Turn off microphone"}>
          {isMuted ? (
            <FaMicrophoneSlash color="#f00" size={20} />
          ) : (
            <VoiceAudioIcon width={20} height={20} />
          )}
        </button>

        <button className="circle-btn" onClick={handleVideoToggle} title={isVideoOff ? "Turn on camera" : "Turn off camera"}>
          {isVideoOff ? (
            <FaVideoSlash color="#f00" size={20} />
          ) : (
            <VideoIcon width={20} height={20} />
          )}
        </button>

        {/* <button className="circle-btn" onClick={() => setShowModelModal(true)} title="Change ai model">
          <img src={AiModelIcon} alt="AI Model" />
        </button> */}
        <button
          className="circle-btn"
          onClick={() => {
            const newModel = selectedExpert === "dietician" ? "psychologist" : "dietician";
            const dispmodel = selectedExpert==="psychologist" ? "Dietician": "Therapist";
            setModalMessage("Transfering to "+dispmodel);
            setSelectedExpert(newModel);
            localStorage.setItem("selectedExpert", newModel);
            //updatePersona(newModel);
            //localStorage.removeItem("conversation_id");
            if (socket && socket.readyState === 1) {
              socket.close();
            }

              
              setTimeout(() => {
                // Start fade-out
              setFadeOut(true);
        
                // Preload current page in hidden iframe
              const iframe = document.createElement("iframe");
              iframe.style.display = "none";
              iframe.src = window.location.href;
              document.body.appendChild(iframe);

              iframe.onload = () => {
            // After fade completes (same as your animation time)
              setTimeout(() => {
              
              updatePersona(newModel);
              setModalMessage(false);

              setFadeOut(false); // reset fade
              // Optional: you can reset state or force remount
              // Forcing navigation to same route using React Router
              window.location.reload();
              //navigate(window.location.pathname, { replace: true, state: { reload: true } });
            }, 200); // match fade-out duration
        };

        //document.body.appendChild(iframe);
        
        }, 1000);
           // window.location.reload();
          }}
        >
          <img src={AiModelIcon} alt="AI Model" />
        </button>

        <button className="circle-btn" onClick={() => setShowVoiceModal(true)} title="Change voice">
          <img src={VoiceModelIcon} alt="Voice Model" />
        </button>

        <div className="divider" />

        <button
          className="circle-btn end-call"
          onClick={() => setShowEndModal(true)} title="End conversation"
        >
          <img src={EndCallIcon} alt="End Call" />
        </button>
      </footer>

      {/* Model Selection Modal */}
      {showModelModal && (
        <div className="voice-modal-overlay">
          <div className="voice-modal">
            <div className="modal-header-indicator" />
            <h3
              style={{
                fontSize: "16px",
                fontWeight: "600",
                marginBottom: "24px",
                fontFamily: "Inter, sans-serif",
              }}
            >
              Choose Your AI Model
            </h3>
            <ul className="voice-list">
              {["psychologist", "dietician"].map((model, index) => (
                <li
                  style={{
                    backgroundColor:
                      model === selectedModelType ? "#dfefff" : "",
                    cursor: "pointer",
                    borderRadius: "8px",
                    padding: "10px",
                    transition: "0.2s",
                  }}
                  key={index}
                  className="voice-item"
                  onClick={handleModelSelect}
                >
                  <span>{model}</span>
                </li>
              ))}
            </ul>
            <div
              className="modal-actions"
              style={{ borderTop: "1px solid #eee", paddingTop: "12px" }}
            >
              <button
                className="cancel"
                onClick={() => setShowModelModal(false)}
                style={{
                  background: "transparent",
                  border: "1px solid #ccc",
                  borderRadius: "12px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#6b7280",
                }}
              >
                Cancel
              </button>
              <button
                className="done"
                disabled={!selectedModelType}
                onClick={() => handleSendSelectedModel()}
                style={{
                  backgroundColor: "#7d6bea",
                  color: "white",
                  borderRadius: "12px",
                  fontSize: "14px",
                  fontWeight: "600",
                  opacity: selectedModelType ? 1 : 0.5,
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Voice Selection Modal */}
      {showVoiceModal && (
        <div className="voice-modal-overlay">
          <div className="voice-modal">
            <div className="modal-header-indicator" />
            <h3
              style={{
                fontSize: "16px",
                fontWeight: "600",
                marginBottom: "20px",
                fontFamily: "Inter, sans-serif",
              }}
            >
              Choose Your AI Model Voice
            </h3>
            <ul className="voice-list" style={{ marginBottom: "24px" }}>
              {[
                "Nova – Female, Soft",
                "Alloy – Neutral",
                "Echo – Male",
                "Fable – Female",
                "Onyx – Male, Deep",
                "Shimmer – Female, Clear",
              ]
              
              .filter((voice) => {
            const lower = voice.toLowerCase();
            if (selectedModelType === "dietician") {
              // only female voices
              return lower.includes("female");
            } else {
              // only male or neutral, exclude female
              //lower.excludes("female");
              return (lower.includes("male") || lower.includes("neutral")) && !lower.includes("female");
            }
          }) 
          .map((voice, index) => (
                <li
                  key={index}
                  className="voice-item"
                  onClick={(index) => handleSetVoice(index)}
                  style={{
                    justifyContent: "space-between",
                    padding: "10px 14px",
                    borderRadius: "12px",
                    backgroundColor: "#fff",
                    border: "1px solid #eee",
                    fontSize: "14px",
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  <span>{voice}</span>
                  <input
                    type="radio"
                    checked={selectedVoice === voice}
                    onChange={() => setSelectedVoice(voice)}
                  />
                </li>
              ))}
            </ul>
            <div
              className="modal-actions"
              style={{ borderTop: "1px solid #eee", paddingTop: "12px" }}
            >
              <button
                className="cancel"
                onClick={() => setShowVoiceModal(false)}
                style={{
                  background: "transparent",
                  border: "1px solid #ccc",
                  borderRadius: "12px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#6b7280",
                }}
              >
                Cancel
              </button>
              <button
                className="done"
                disabled={!selectedVoice}
                onClick={handleVoiceSelect}
                style={{
                  backgroundColor: "#7d6bea",
                  color: "white",
                  borderRadius: "12px",
                  fontSize: "14px",
                  fontWeight: "600",
                  opacity: selectedVoice ? 1 : 0.5,
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}

      {/* End Call Modal */}
      {showEndModal && (
        <div className={`voice-modal-overlay closing-fade ${fadeOut ? "fade-out" : ""}`}>
          <div className="voice-modal">

            {isClosing ? (
              
        <h3 style={{ color: "#7D4AEA", fontWeight: 600 }}>
          Closing video session...
        </h3>
        
      ) : (
        <>
        
            <h3 style={{ color: "#7D4AEA", fontWeight: 600 }}>
              Are you sure you want to end this call?
            </h3>
            <div className="modal-actions">
              
              <button className="cancel"  onClick={handleStayActive} >
                Stay on call
              </button>
              <button
                className="done" 
                  onClick={handleEndSession}
                  style={{
                  background: "#ff4d4f",
                  color: "white",
                  border: "none",
                }}
              >
                End Now
              </button>
            </div>
             </>
          )}
          </div>
        </div>
      )}

      
      {showIdleModal && (
        <div className="voice-modal-overlay">
          <div className="voice-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-indicator" />
            <h3 style={{ fontWeight: 600, marginBottom: 6 }}>Still there?</h3>
            <p style={{ marginBottom: 14 }}>You’ve been inactive for a while.</p>
            <div className="modal-actions">
              <button className="cancel" onClick={handleStayActive}>Stay</button>
              <button className="done" onClick={handleEndSession}>End Session</button>
            </div>
          </div>
        </div>
      )}


      {modalMessage && (
            
            <div className="feedback-modal-overlay">
                    <div className="feedback-modal">
                  <img
                    src={logo}
                    alt="Prashasync Logo"
                    className="modal-logo-google"
                  />
                  <h3>Please wait… </h3>
                  <p>{modalMessage} </p>
                </div>
              </div>
            
              
            )}

    </div>
  );
};

export default VideoSession;
